import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AreaService } from 'src/app/services/Area/area.service';

@Component({
  selector: 'app-content-page',
  templateUrl: './content-page.page.html',
  styleUrls: ['./content-page.page.scss'],
})
export class ContentPagePage implements OnInit {

  constructor(
    private navCtrl:NavController,
   private areaService:AreaService

    ) { }

  ngOnInit() {
  }
  goback(){
    this.navCtrl.navigateBack('/app/about');
  }
  ionViewDidEnter() {
    this.areaService.showHome=false  
  }
}
